import { useEffect, useRef } from "react";
import { crops } from "../data/siteData";
import "./Crops.css";

export default function Crops() {
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("visible"); obs.unobserve(e.target); } }),
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
  }, []);

  return (
    <section id="crops" className="section crops" ref={ref}>
      <div className="crops__header reveal">
        <div>
          <span className="section-eyebrow">Crop Coverage</span>
          <h2 className="section-title">One Partner.<br /><em>60+ Crops.</em></h2>
        </div>
        <p className="crops__sub">
          From staple grains to specialty fruits and vegetables, CropShield has a registered, proven
          product for nearly every commercial crop grown worldwide.
        </p>
      </div>
      <div className="crops__grid reveal">
        {crops.map((c) => (
          <div className="crop-card" key={c.name}>
            <span className="crop-card__emoji">{c.emoji}</span>
            <span className="crop-card__name">{c.name}</span>
          </div>
        ))}
        <div className="crop-card crop-card--more">
          <span className="crop-card__emoji">+</span>
          <span className="crop-card__name">48 More</span>
        </div>
      </div>
    </section>
  );
}
